import { render, staticRenderFns } from "./salesCarManagement.vue?vue&type=template&id=50525108&scoped=true&"
import script from "./salesCarManagement.vue?vue&type=script&lang=js&"
export * from "./salesCarManagement.vue?vue&type=script&lang=js&"
import style0 from "./salesCarManagement.vue?vue&type=style&index=0&id=50525108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50525108",
  null
  
)

export default component.exports